import React, { FC, useMemo } from 'react';

interface ITextWithBreaksProps {
	text?: string | null;
	prefix: string;
}

export const TextWithLineBreaks: FC<ITextWithBreaksProps> = ({ text, prefix }) => {
	const textWithBreaks = useMemo(() => {
		const safe = text == null ? '' : String(text);
		return safe.split('\n').map((line, index) => (
			<React.Fragment key={`${index}-${prefix}`}>
				{line}
				<br />
			</React.Fragment>
		));
	}, [text, prefix]);

	return <>{textWithBreaks}</>;
};
